import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
import AddHoliday from './AddHoliday';
import DashboardHeading from '../commonFiles/DashboardHeading';

class ViewHoliday extends Component {
  constructor() {
    super();
    this.state = {
      all_table_row:[],
      addNewEventPopup:'',
    };
  }

formatTime(timeString) {
    const [hourString, minute] = timeString.split(":");
    const hour = +hourString % 24;
    return (hour % 12 || 12) + ":" + minute + (hour < 12 ? "AM" : "PM");
}

show_list(list){

  var all_table_row = [];
  if(list.length>0){
    var no =1;
    for(var i=0; i<list.length; i++){
    var list_data       = list[i];
    var holiday_title   = list_data['holiday_title'];
    var holiday_date    = list_data['holiday_date'];
    var description     = list_data['description'];
    var holiday_status  = list_data['holiday_status'];
    var view_icon       = [];
      view_icon.push(<a className="pointer leave_icon" title="View"><i class="fas fa-eye"></i></a>);
      all_table_row.push(<tr>
        <td>{no}</td>
        <td>{holiday_title}</td>
        <td>{holiday_date}</td>
        <td>{description}</td>
        <td>{holiday_status}</td>
        <td>{view_icon}</td>
        </tr>);
        no++;
    }
  }else{
    all_table_row.push(<tr><td colspan="7">No Holiday</td></tr>);
  }
  this.setState({all_table_row});
}

get_all_event_list(){
  var cutThis        = this;
  var web_token     = window.isNullAndUndef($('#web_token').val());
  var body          = new FormData();
  body.append('web_token',web_token);
  body.append('function','get_all_event_data');
  var url      = '';
  if(window.location.host ==="localhost:3000"){
    url = "http://localhost/bylawsindia/php/admin_holiday_manage_url.php";
  }else{
    url = "/php/admin_holiday_manage_url.php";
  }
  axios({
       method: 'POST',
       url: url,
       async: false,
       data: body,
       enctype: 'multipart/form-data',
       processData: false,
       contentType: false,
       cache: false,
   })
   .then(function (res) {
      var data = res.data;
      cutThis.show_list(data);
   })
   .catch(function (error) {
       console.log(error);
   });
}


componentDidMount(){
  this.get_all_event_list();
}

schedule_consultation(){
  var addNewEventPopup = <AddHoliday close_popup_view={this.close_popup.bind(this)}/>;
  this.setState({addNewEventPopup});
  setTimeout(function (){window.model_show();},100);
}

close_popup(){
  window.model_hide();
  var addNewEventPopup = '';
  this.setState({addNewEventPopup});
  this.get_all_event_list();
}

  render() {
    return (
        <>
        <DashboardHeading title="Holiday Management"/>
        	<div className="container mt-4 mb-4 Dashboard_main_div">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">Holiday Management</h3>


                <div className="col-md-12 p-0">
                <div className="col-md-3 p-0 float_r">
                      <button className="btn btn-primary w-100 py-3" type="button" onClick={this.schedule_consultation.bind(this)}>Add Holiday</button>
                </div>

                <table class="table">
                <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">Title</th>
                <th scope="col">Date</th>
                <th scope="col">Description</th>
                <th scope="col">Status</th>
                <th scope="col" className="text_align_center" colspan="2">Action</th>
                </tr>
                </thead>
                <tbody>
                {this.state.all_table_row}
                </tbody>
                </table>

            </div>
            {this.state.addNewEventPopup}
        </div>
        </>
    );
  }
}

export default ViewHoliday;
